import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { BannerMessage, BannerService } from './banner.service';

@Component({
  selector: 'banner',
  imports: [NgClass],
  template: `@if (message.Text) {
    <div class="banner" [ngClass]="{ error: message.IsError }" (click)="hideNow()">
      {{ message.Text }}
    </div>
  }`
})
export class BannerComponent {
  private bannerService = inject(BannerService);

  message: BannerMessage;
  private messageTimeout: number;

  constructor() {
    // subscribe to banner service
    this.bannerService.message.subscribe(bMess => {
      window.clearTimeout(this.messageTimeout);

      this.message = bMess;
      this.messageTimeout = window.setTimeout(
        () => (this.message.Text = ''),
        this.message.TimeoutExpire
      );
    });
  }

  hideNow() {
    this.message.Text = '';
    window.clearTimeout(this.messageTimeout);
  }
}
